import { OfficeServiceEnum } from "../../components/enums/OfficeService";
import { OfficePersistor } from "../OfficePersistor";
import { OutlookPersistor } from "../OutlookPersistor";
import { IPersistor } from "../../interfaces/IPersistor";
import { IMailSendPayload } from "../../interfaces/IMailSendPayload";
import { ModeEnum } from "../../components/enums/modeEnum";

export class PersistorFactory {
  static create(serviceType: OfficeServiceEnum, mailSendPayload: IMailSendPayload, mode: ModeEnum, isFileSystemFileUpload: boolean, disableMailCategorization?: boolean): IPersistor {
    switch (serviceType) {
      case OfficeServiceEnum.outlook:
        return new OutlookPersistor(mailSendPayload, mode, disableMailCategorization ?? false);
      default:
        return new OfficePersistor(isFileSystemFileUpload);
    }
  }
}
